，<!--今日客户任务-->
<template>
  <article>
    <div ref="header">
      <div class="plarform-search">
        <a href="javascript:void(0);" class="search-icon" @click.stop="search"></a>
        <input v-model="mobile" type="text" class="search-number" placeholder="请输联系电话">
      </div>
      <div class="tab-service">
        <ul class="tab-service-detail">
          <li :class="{'on':status===1}" @click="onShiftTap(1)"><a href="javascript:void(0);">待跟进</a></li>
          <li :class="{'on':status===2}" @click="onShiftTap(2)"><a href="javascript:void(0);">已签单</a>
          </li>
          <li :class="{'on':status===4}" @click="onShiftTap(4)"><a href="javascript:void(0);">待审核</a>
          </li>
          <li :class="{'on':status===3}" @click="onShiftTap(3)"><a href="javascript:void(0);">已成交</a>
          </li>
          <li :class="{'on':status===5}" @click="onShiftTap(5)"><a href="javascript:void(0);">已战败</a></li>
        </ul>
      </div>
    </div>

    <!-- height要算准确 -->
    <scroller
      lock-x scrollbar-y
      use-pullup
      ref="myScroller"
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      :height="scrollerHeight">
      <div class="mt-20">
      <group v-for="(item,index) in customerList" :key="index">
        <cell class="personal-info-detail">
          <p slot="after-title">姓名：{{item.customer_name}}<span class="label">{{item.intention_level}}级</span></p>
          <i slot="value" class="phone-icon-right" @click.stop="makeACall(item.mobile)"></i>
        </cell>
        <cell class="personal-info-detail" @click.native="toArchives(item.id)">
          <div slot="after-title" class="title-list">
            <p v-for="(v, index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span></p>
          </div>
          <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
          <p slot="after-title" class="info">下次致电：{{item.next_contact_at}}</p>
          <p slot="after-title" class="info">最近联系：{{item.last_contact_at}}</p>
          <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
        </cell>
      </group>
      <p class="tip-text1">共有{{statistics.total_num}}位客户,待跟进{{statistics.follow_up_num}}位,已签单{{statistics.signed_num}}位,待审核{{statistics.review_num}}位,已成交{{statistics.deal_num}}位,已战败{{statistics.fail_num}}位</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import util from '../../../common/util'
import cache from '../../../common/cache'

export default {
  components: {
    Scroller,
    Cell,
    Group
  },
  data () {
    return {
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      mobile: '',
      totalCount: 0,
      totalPage: 1,
      item_per_page: 20,
      page: 1,
      status: 1,
      customerList: [],
      statistics: {},
      scrollerHeight: ''
    }
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    this.$rest.saleManage.customerStatistics().then(res => {
      if (res.code === 0) {
        this.statistics = res.data
      }
    }).then(() => {
      this.getCustomerList()
    })
  },
  methods: {
    loadMore (done) {
      if (this.page < this.totalPage) {
        ++this.page
        this.$rest.saleManage.getAllCustomers({
          page: this.page,
          mobile: this.mobile,
          item_per_page: this.item_per_page,
          status: this.status
        }).then(res => {
          if (res.code === 0) {
            this.customerList.push(...res.data.customers)
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
            done(100)
          }
        })
      } else {
        done()
      }
    },
    getCustomerList () {
      this.$rest.saleManage.getAllCustomers({
        page: this.page,
        mobile: this.mobile,
        item_per_page: this.item_per_page,
        status: this.status
      }).then(res => {
        if (res.code === 0) {
          this.customerList = res.data.customers
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    search () {
      if (!this.mobile) {
        this.showToast('请输入联系电话')
        return false
      } else if (!util.regexpMap.regexp_mobile.test(this.mobile)) {
        this.showToast('请输入正确的号码')
        return false
      }
      this.page = 1
      this.totalPage = 1
      this.customerList = []
      this.getCustomerList()
    },
    onShiftTap (status) {
      if (this.status === status) return
      this.status = status
      this.page = 1
      this.customerList = []
      this.getCustomerList()
    },
    makeACall (phone) {
      window.location.href = 'tel:' + phone
    },
    toArchives (id) {
      cache.clearSessionData('customerArchivesLocalData')
      this.$router.push({ path: '/salemanage/staff/customerarchives', query: { id: id } })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
